<template>
  <SearchNavBar
    v-model:value="keywords"
    @onSearch="onNavSearch"
    class="fixed-navbar"
  />
  <div class="content">
    <van-sidebar v-model="activeIndex" @change="handleCategoryChange">
      <div class="scroll-content">
        <van-sidebar-item
          :title="item.category_name"
          v-for="item in categoryList"
          :key="item.id"
        />
      </div>
    </van-sidebar>

    <div class="right">
      <div class="filter">
        <van-dropdown-menu active-color="#FF5D7D">
          <van-dropdown-item
            v-model="query.sort_type"
            :options="option"
            @change="onSearch"
          />
        </van-dropdown-menu>
      </div>

      <div class="right-list">
        <div
          class="item"
          v-for="item in goodsList"
          :key="item.guid"
          @click="handleGoodsItem(item)"
        >
          <div class="left">
            <div>
              <p class="title">{{ item.goods_name }}</p>
              <p class="subhead">{{ item.goods_subtitle }}</p>
              <p class="price">
                <span v-if="item.is_limit_time_free">免费测试</span>
                <span v-else>￥{{ item.goods_sale_price }}</span>
              </p>
            </div>
            <p class="num fa fa-heart">{{ item.goods_vr_sale_count }}人测过</p>
          </div>
          <div class="right-img">
            <van-image :src="item.goods_cover_image"> </van-image>
          </div>
        </div>
        <div class="bottom">
          <van-loading v-show="loading" size="18px">加载中...</van-loading>
          <div class="none" v-show="nomore">没有更多数据了</div>
        </div>
        <CopyRight />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, onActivated } from "vue";
import { useRouter, useRoute } from "vue-router";
import SearchNavBar from "@/components/SearchNavBar";
import { getCategoryList, getGoodsList } from "@/api/category";
import { useScrollBottom } from "@/hooks/useScroll";
import { useWx } from "@/hooks/useWx";
import CopyRight from "@/components/CopyRight";

export default {
  name: "category",
  components: {
    SearchNavBar,
    CopyRight,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      activeIndex: 0,
      option: [
        { text: "按时间", value: 1 },
        { text: "按热度", value: 2 },
        { text: "按价格", value: 3 },
      ],
      goodsList: [],
      categoryList: [],
      nomore: false,
      loading: false,
      keywords: "",
      query: {
        goods_category_id: 0,
        limit: 10,
        page: 1,
        goods_name: "",
        sort_type: 2,
      },
    });
    onActivated(() => {
      useWx({ type: 1 });

      if (route.query.id) {
        state.query.goods_category_id = route.query.id;
        setActiveIndex();
        onSearch();
      } else {
        const id = state.categoryList[state.activeIndex]?.id ?? 0;
        setSearch(id);
      }
    });

    function onNavSearch() {
      router.push({
        path: "/search",
        query: {
          keywords: state.keywords,
        },
      });
    }
    // 获取分类列表
    async function init() {
      const { data } = await getCategoryList();
      state.categoryList = data;
      setActiveIndex();
    }
    onMounted(() => {
      init();
      getList();
    });
    // 设置分类选中
    function setActiveIndex() {
      const index = state.categoryList.findIndex((v) => v.id == route.query.id);
      if (index !== -1) {
        state.activeIndex = index;
      }
    }

    // 获取商品列表
    async function getList() {
      if (state.nomore) return;
      state.loading = true;
      const { data } = await getGoodsList(state.query);
      state.loading = false;
      if (!data.data.length) {
        state.nomore = true;
        return;
      }
      state.goodsList = [...state.goodsList, ...data.data];
    }
    function setSearch(id) {
      const search = `?id=${id}`;
      window.history.replaceState(
        history.state,
        "",
        `${window.location.origin + route.path + search}`
      );
    }
    // 分类切换事件
    function handleCategoryChange(index) {
      const current = state.categoryList[index];
      state.query.goods_category_id = current.id;
      onSearch();
      setSearch(current.id);
    }
    // 商品点击
    function handleGoodsItem({ guid }) {
      router.push({
        path: "/goods",
        query: {
          guid,
        },
      });
    }
    function onSearch() {
      state.query.page = 1;
      state.goodsList = [];
      state.nomore = false;
      getList();
    }

    // 触底
    useScrollBottom(() => {
      if (state.nomore) return;
      state.query.page++;
      getList();
    });

    return {
      handleGoodsItem,
      handleCategoryChange,
      onSearch,
      onNavSearch,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" scoped>
.fixed-navbar {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 375px;
  z-index: 1;
}

.filter {
  position: fixed;
  top: 50px;
  right: calc(50% - 187px);
  width: 295px;
  z-index: 1;

  :deep(.van-dropdown-item__option--active, .van-dropdown-menu__title--active) {
    color: @theme-color;
  }
}

@media screen and (min-width: @max-device-width) {
  .filter {
    :deep(.van-dropdown-item) {
      width: calc(@max-device-width - 80px) !important;
      right: calc((100vw - @max-device-width) / 2) !important;
    }
  }
}

.content {
  .space-between();

  .right {
    background-color: @bg-color;
    margin-top: 100px;
    width: calc(100% - 80px);

    .right-list {
      .bottom {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: @padding-sm 0;

        .none {
          color: #969799;
          font-size: @font-size-base;
        }
      }

      .item {
        .pointer();
        // height: 100px;
        padding: @padding-sm;
        border-radius: 5px;
        border: 1px solid #efefef;
        box-shadow: #efefef 2px 2px 4px 1px;
        background: #fff;
        margin: @padding-sm @padding-sm 0 @padding-sm;

        .space-between();

        .left {
          width: calc(100% - 80px);
        }

        .right-img {
          width: 80px;
          height: 80px;

          :deep(.van-image) {
            width: 100%;
            height: 100%;

            img {
              border-radius: @radius-base;
            }
          }
        }

        .left {
          font-size: @font-size-base;
          padding-right: @padding-sm;
          .column-space-between();
          .price {
            font-size: 14px;
            color: @theme-color;
            padding: 4px 0;
          }
          .title {
            font-weight: bold;
  
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .subhead {
            color: @gray-color;
            font-size: @font-size-sm;
            line-height: 24px;
            .ellipsis();
          }

          .num {
            font-size: @font-size-sm;

            &::before {
              color: @theme-color;
            }
          }
        }
      }
    }
  }
}

.scroll-content {
  background-color: #fff;
  position: fixed;
  top: 50px;
  width: 80px;
  height: 100%;
}

:deep(.van-dropdown-menu) {
  .van-ellipsis {
    font-size: @font-size-base;
  }

  .van-dropdown-menu__bar {
    box-shadow: none;
  }

  .van-dropdown-item--down {
    width: calc(100vw - 80px);
    right: 0;
    left: unset;

    :deep(.van-popup) {
      border-bottom: 1px solid @gray-color;
    }
  }

  .van-dropdown-menu__item {
    justify-content: flex-end;
    padding: 0 @padding-base;
    position: relative;

    &::before {
      content: "排序";
      position: absolute;
      left: @padding-base;
      top: 50%;
      transform: translateY(-50%);
      font-size: @font-size-base;
      color: @gray-color;
    }
  }
}

.van-sidebar-item {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: @font-size-base;
  color: @gray-color;
  background-color: #fff;
}

.van-sidebar-item--select {
  font-weight: bold;
  /*color: @light-black;*/
  color: #000000;

  &::before {
    height: 100%;
    width: 3px;
    background-color: @theme-color;
  }
}
</style>